import executeRequest, { RequestOutput } from 'app/api'


enum APIEndpoint {
  AuthenticateUser = 'api/login',
  UpdateUserPassword = 'api/update-password',
  ResetUserPassword = 'api/reset-password',
}



//Retrieve the authentication token.
//Used when logging in and authorizing the client to make future API calls.

type AuthenticateUserRequestParams = {
  username: string
  password: string
}

type AuthenticateUserResponse = {
  token: string
}

enum AuthenticateUserReponseError {
}

export async function authenticateUser(params: AuthenticateUserRequestParams, output?: RequestOutput<AuthenticateUserResponse, AuthenticateUserReponseError>) {
  executeRequest({
    endpoint: APIEndpoint.AuthenticateUser,
    params: params,
    output: output,
  })
}




//Reset the user password.
//This send an automated email to the email provided with an auto-generated password.

export type UpdateUserPasswordRequestParams = {
  username: string
  password: string
  newPassword: string
}

type UpdateUserPasswordResponse = {
}

type UpdateUserPasswordResponseError = {
}

export async function updateUserPassword(params: UpdateUserPasswordRequestParams, output?: RequestOutput<UpdateUserPasswordResponse, UpdateUserPasswordResponseError>) {
  executeRequest({
    endpoint: APIEndpoint.UpdateUserPassword,
    params: params,
    output: output,
  })
}



//Reset the user password.
//This send an automated email to the email provided with an auto-generated password.

type ResetUserPasswordRequestParams = {
  email: string
  locale: string
}

type ResetUserPasswordResponse = {
}

type ResetUserPasswordResponseError = {
}

export async function resetUserPassword(params: ResetUserPasswordRequestParams, output?: RequestOutput<ResetUserPasswordResponse, ResetUserPasswordResponseError>) {
  executeRequest({
    endpoint: APIEndpoint.ResetUserPassword,
    params: params,
    output: output,
  })
}